var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "accordionContainer" }, [
    _c(
      "div",
      { ref: "expandableContainer", staticClass: "accordionHeadingContainer" },
      [
        _c("h3", [
          _c(
            "button",
            {
              ref: "expandableButton",
              staticClass: "accordionButton",
              attrs: {
                type: "button",
                "aria-label": _vm.accordionButtonState,
                "aria-expanded": _vm.showExpandableContent
              },
              on: { click: _vm.expandToggle }
            },
            [
              _vm._t("header"),
              _vm._v(" "),
              _c("span", { staticClass: "toggleButton" })
            ],
            2
          )
        ])
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        ref: "expandableContent",
        staticClass: "accordionContent",
        attrs: { "aria-hidden": !_vm.showExpandableContent }
      },
      [_vm._t("content")],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }